<template>
  <div>

    <b-form-group>
      <label :for="id">{{ label }}</label>
      <validation-provider
        #default="{ errors }"
        :name="errorName"
        :rules="rules"
        :vid="vid"
      >
        <flat-pickr
          :id="id"
          v-model="innerValue"
          :value="value"
          :mode="mode"
          :click-opens="true"
          class="form-control"
          :class="disabled ? 'disabled' : ''"
          :placeholder="placeholder"
          :config="config"
          :readonly="readonly"
          :state="errors.length > 0 ? false:null"
          :disabled="disabled"
          @on-change="onChange"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

  </div>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'

const modeTypes = ['single', 'multiple', 'range']
export default {
  name: 'DatePickerField',
  components: {
    BFormGroup,
    ValidationProvider,
    flatPickr,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    errorName: {
      type: String,
      default: 'default',
    },
    value: {
      type: null,
      default: '',
    },
    vid: {
      type: String,
      default: '',
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    onChange: {
      type: Function,
      default: () => {},
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      required: false,
      default: 'single',
      validator: value => modeTypes.includes(value),
    },
    // eslint-disable-next-line vue/require-default-prop
    placeholder: {
      type: String,
      required: false,
    },
    readonly: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      innerValue: '',
    }
  },
  computed: {
    hasValue() {
      return !!this.innerValue
    },
  },
  watch: {
    innerValue(value) {
      this.$emit('input', value)
    },
    value(val) {
      if (val !== this.innerValue) {
        this.innerValue = val
      }
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
}
</script>
<style lang="scss" scoped>
.disabled{
  background-color: #efefef !important;
}
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
